angular.module('dnecom')
    .controller('CronManagerController', ["$scope", "$window", "notifications", function($scope, $window, notifications) {
        $scope.flashError = TemplateData.value('flashError');
        $scope.flashSuccess = TemplateData.value('flashSuccess');

        if ($scope.flashError && $scope.flashError.length > 0) {
            _.each($scope.flashError, function (message) {
                notifications.danger(message);
            });
        }

        if ($scope.flashSuccess && $scope.flashSuccess.length > 0) {
            _.each($scope.flashSuccess, function (message) {
                notifications.success(message);
            });
        }

        $scope.deleteCommand = function (id) {
            $window.location.href = Routing.generate('jmose_command_scheduler_action_remove', { id: id });
        };

        $scope.executeCommand = function (id) {
            $window.location.href = Routing.generate('jmose_command_scheduler_action_execute', { id: id });
        };

        $scope.unlockCommand = function (id) {
            $window.location.href = Routing.generate('jmose_command_scheduler_action_unlock', { id: id });
        };
    }]);